__turbopack_context__.v({
  "badge": "Badge-module__nLm0IW__badge",
  "disabled": "Badge-module__nLm0IW__disabled",
  "interactive": "Badge-module__nLm0IW__interactive",
});
